import React, { createContext, useContext, useEffect, useState } from "react";

import { scrollPage, useLocation } from "utils";

export const NavContext = createContext({ showHeader: false, showNavbar: false, toggleNavs: () => {} });

export const useNavContext = () => useContext(NavContext);

export function useToggleNavs(navBar, header) {
  const { toggleNavs } = useNavContext();

  useEffect(() => {
    toggleNavs(navBar, header);
  }, []); //eslint-disable-line

  return { toggleNavs };
}

export const NavContextProvider = ({ children }) => {
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState(location.pathname);
  const [showHeader, setShowHeader] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);

  const noNav = [
    "/t/",
    "/sign-in",
    "/sign-up",
    "/confirm-account",
    "/password",
    "/sign-out",
    "/manage-notifications",
    "/update-app",
    "/sign-in",
    "/password",
    "/sign-out",
    "/confirm-sign-in",
  ];

  // toggle the nav or header
  const toggleNavs = (navBar, header) => {
    setCurrentLocation(location.pathname);
    setTimeout(() => {
      setShowNavbar(navBar);
      setShowHeader(header);
    }, 50);
  };

  // show head and nav if location changed and not toggling
  useEffect(() => {
    if (!noNav.some((v) => currentLocation.includes(v)) && !noNav.some((v) => currentLocation.includes(v.replace("/", "#")))) {
      setShowHeader(true);
      setShowNavbar(true);
    } else if (noNav.some((v) => currentLocation.includes(v))) {
      setShowHeader(false);
      setShowNavbar(false);
    }
    scrollPage();
  }, [currentLocation]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setCurrentLocation(location.pathname);
  }, [location.pathname]);

  return (
    <NavContext.Provider
      value={{
        showHeader,
        showNavbar,
        toggleNavs,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};
